import { Link, useParams } from "react-router-dom";
import { Card, EmptyState, PageHeader } from "@/components/ui";
import { useConversation, useConversations } from "@/lib/api";
import { cn } from "@/lib/cn";

export function ConversationsScreen() {
  const convos = useConversations();
  const items = convos.data?.items ?? [];
  return (
    <>
      <PageHeader
        title="Conversations"
        subtitle="What visitors asked, most recent first."
      />
      <Card className="p-0">
        {items.length === 0 ? (
          <EmptyState
            title="No conversations yet."
            hint="Install the widget and they will show up here."
          />
        ) : (
          <ul className="divide-y divide-border">
            {items.map((c) => (
              <li key={c.id}>
                <Link
                  to={`/conversations/${c.id}`}
                  className="flex items-center justify-between gap-3 px-5 py-3 hover:bg-surface-2"
                >
                  <div className="min-w-0">
                    <p className="truncate text-[13px] font-medium">
                      {c.pageUrl ?? "Unknown page"}
                    </p>
                    <p className="text-[12px] text-muted">
                      {c.messageCount} messages
                      {c.hasLead ? " · left details" : ""}
                    </p>
                  </div>
                  <span className="whitespace-nowrap text-[12px] text-muted">
                    {new Date(c.lastMessageAt).toLocaleString()}
                  </span>
                </Link>
              </li>
            ))}
          </ul>
        )}
      </Card>
    </>
  );
}

export function ConversationScreen() {
  const { conversationId = "" } = useParams();
  const convo = useConversation(conversationId);
  const data = convo.data;
  return (
    <>
      <PageHeader
        title="Conversation"
        subtitle={
          data
            ? `${data.conversation.pageUrl ?? "Unknown page"} · started ${new Date(data.conversation.startedAt).toLocaleString()}`
            : "…"
        }
        action={
          <Link to="/conversations" className="text-[13px] text-accent">
            All conversations
          </Link>
        }
      />
      <Card className="flex flex-col gap-2">
        {(data?.messages ?? []).map((m) => (
          <div
            key={m.id}
            className={cn(
              "max-w-[80%] rounded-panel px-4 py-2 text-[13px]",
              m.role === "user"
                ? "self-end bg-accent text-white"
                : "self-start border border-border bg-bg",
            )}
          >
            {m.content}
          </div>
        ))}
      </Card>
    </>
  );
}
